import * as React from "react";
import "./datePicker.scss";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const MuiDatePicker = ({ onChange, selected, minDate }) => {
  return (
    <div className="datePicker">
      <DatePicker selected={selected} onChange={onChange} minDate={minDate} />
    </div>
  );
};

export default MuiDatePicker;
